// Demo showcase data. Add new entries here — the layout adapts automatically.
export const DEMOS = [
  {
    id: "concept-a",
    title: "GreenScape Outdoor Design (Concept A)",
    tag: "Concept site",
    description:
      "A full landscaping company site with a project gallery, service pages, and an estimate-request form that saves every inquiry to a private lead dashboard.",
    features: [
      "Project gallery",
      "Service pages",
      "Estimate form",
      "Lead dashboard",
      "Mobile-ready",
    ],
    url: "https://landscape-pro-86.preview.emergentagent.com/",
    desktopShot: "demo-a-desktop.jpg",
    mobileShot: "demo-a-mobile.jpg",
    desktopAlt: "Concept A sample landscaping website shown on a desktop screen",
    mobileAlt: "Concept A sample landscaping website shown on a phone screen",
  },
  {
    id: "concept-b",
    title: "GreenScape Outdoor Design (Concept B)",
    tag: "Concept site",
    description:
      "An alternate design direction for the same company, showing a different layout and visual style for presenting projects and services.",
    features: [
      "Alternate design",
      "Project showcase",
      "Estimate form",
      "Mobile-ready",
    ],
    url: "https://terra-form-leads.lovable.app",
    desktopShot: "demo-b-desktop.jpg",
    mobileShot: "demo-b-mobile.jpg",
    desktopAlt: "Concept B sample landscaping website shown on a desktop screen",
    mobileAlt: "Concept B sample landscaping website shown on a phone screen",
  },
];
